import mod from "-!../../../../babel-loader/lib/index.js??ref--10-0!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./EditHeatmapOrGridDataContainer.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../../../babel-loader/lib/index.js??ref--10-0!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./EditHeatmapOrGridDataContainer.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/EditHeatmapOrGridDataContainer.vue?vue&type=script&lang=js&
// module id = 29
// module chunks = 0